(function() {
  let cachedProductData = null;

  async function getProductData() {
    if (cachedProductData) return cachedProductData;

    // 1. Embedded JSON scripts
    const jsonScripts = document.querySelectorAll('script[type="application/json"]');
    for (let script of jsonScripts) {
      if (script.textContent.includes('variants')) {
        try {
          const parsed = JSON.parse(script.textContent);
          const data = parsed.product || parsed;
          if (data && data.variants) {
            cachedProductData = data;
            return cachedProductData;
          }
        } catch(e) {}
      }
    }

    // 2. Analytics object
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      cachedProductData = window.ShopifyAnalytics.meta.product;
      return cachedProductData;
    }

    // 3. Fallback product API fetch
    try {
      const pathSegments = window.location.pathname.split('/products/');
      if (pathSegments.length > 1) {
        const handle = pathSegments[1].split('?')[0];
        const res = await fetch(`/products/${handle}.js`);
        if (res.ok) {
          cachedProductData = await res.json();
          return cachedProductData;
        }
      }
    } catch(e) {}

    return null;
  }

  async function selectGmcVariant() {
    const urlParams = new URLSearchParams(window.location.search);
    const targetVariantId = urlParams.get('variant');
    if (!targetVariantId) return false;

    const productData = await getProductData();
    if (!productData || !productData.variants) return false;

    const variantObj = productData.variants.find(v => String(v.id) === String(targetVariantId));
    if (!variantObj) return false;

    // Extract target options
    let targetOptions = [];
    if (variantObj.option1) {
      targetOptions.push(variantObj.option1);
      if (variantObj.option2) targetOptions.push(variantObj.option2);
      if (variantObj.option3) targetOptions.push(variantObj.option3);
    } else if (variantObj.public_title) {
      targetOptions = variantObj.public_title.split(' / ').map(s => s.trim());
    } else if (variantObj.options) {
      targetOptions = variantObj.options;
    }

    if (targetOptions.length === 0) return false;

    // Pass 1: Set Option 1
    const opt0 = document.getElementById('product-option-0');
    if (opt0 && opt0.value !== targetOptions[0]) {
      opt0.value = targetOptions[0];
      opt0.dispatchEvent(new Event('change', { bubbles: true }));
      
      // Brief delay to let Booster Theme rebuild Option 2 DOM options
      await new Promise(r => setTimeout(r, 100));
    }

    // Pass 2: Set Option 2 (if present)
    if (targetOptions.length > 1) {
      const opt1 = document.getElementById('product-option-1');
      if (opt1 && opt1.value !== targetOptions[1]) {
        opt1.value = targetOptions[1];
        opt1.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Pass 3: Set Option 3 (if present)
    if (targetOptions.length > 2) {
      const opt2 = document.getElementById('product-option-2');
      if (opt2 && opt2.value !== targetOptions[2]) {
        opt2.value = targetOptions[2];
        opt2.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Verify all options match target
    return targetOptions.every((val, idx) => {
      const el = document.getElementById(`product-option-${idx}`);
      return el && el.value === val;
    });
  }

  window.addEventListener('load', function() {
    let attempts = 0;
    const timer = setInterval(async function() {
      attempts++;
      const success = await selectGmcVariant();
      if (success || attempts > 20) {
        clearInterval(timer);
      }
    }, 300);
  });
})();